import React from "react";
import Title from "./Title";
import Divider from "./Divider";

type PopUpHeaderProps = {
    id?: string;
    title?: string
}

const PopUpHeader = ({id, title}: PopUpHeaderProps) => {
    const baseId = id || 'popup-header';
    return (
        <div id={baseId} data-testid={baseId}>
        <div id={`${baseId}-content`} className='tw-flex tw-items-center tw-py-3 tw-px-3'>
            <Title id={`${baseId}-title`} title={title ?? ''}/>
        </div>
        <Divider id={`${baseId}-divider`} />
    </div>
    );
}

export default PopUpHeader;